module.exports.OrganizationMap = {
    "nautica2": "Nautica",
    "rivera_isles": "Rivera Isles",
    "carillon_club": "Carillon Club",
    "seaside": "Seaside",
    "disney-contino": "Contino",
    "legacyClubCabo": "Legacy Club"
}

module.exports.OrganizationNameMap = {
    "nautica2": "Nautica",
    "seaside": "Seaside",
    "disney-contino": "Contino",
    "legacyClubCabo": "Legacy Club"
}

module.exports.OrganizationConfig = {
    namingMap: this.OrganizationNameMap,
    colorMap: {
        colorPrimary: "#699991"
    }
}